<template>
  <div>
    <mobile-header
      :menu-toggled="isMobileMenuToggled"
      @toggle-menu="isMobileMenuToggled = !isMobileMenuToggled"
      @toggle-tutorial="$emit('toggle-tutorial', $event)"
    />

    <mobile-menu
      :doctor.sync="doctor"
      :profile="profile"
      :access-roles="accessRoles"
      :profile-routes="profileRoutes"
      :is-mobile-menu-toggled="isMobileMenuToggled"
      @toggle-menu="isMobileMenuToggled = !isMobileMenuToggled"
      @show-action-modal="$emit('show-action-modal', $event)"
     />
  </div>
</template>

<script>
import mobileHeader from '@/components/layout/mobile/mobileHeader'
import mobileMenu from '@/components/layout/mobile/mobileMenu'

export default {
  props: {
    doctor: {
      type: Object,
      default: null
    },
    profile: {
      type: Object,
      default: null
    },
    accessRoles: {
      type: Array,
      default: null
    },
    profileRoutes: {
      type: Array,
      default: null
    }
  },
  components: {
    mobileHeader,
    mobileMenu
  },
  data () {
    return {
      isMobileMenuToggled: false
    }
  }
}
</script>
